import * as yup from "yup";
import { validationSchemas } from "../data";
export const branchPaymentSchema = yup.object().shape({
  currency: validationSchemas.name,
  serviceCharge: validationSchemas.serviceCharge,
  vat: validationSchemas.vat,
});
